import React from 'react';

import Container from './Container';
import Text from './Text';
import Image from './Image';
import Status from './Status';
import Date from './Date';

export default ({ order }) => (
  <Container>
    <Image src={order.image} />
    <Text>
      {order.buyer} ({order.dropoff})
    </Text>
    <Status>{order.human_status}</Status>
    <Date>{order.updated_at}</Date>
  </Container>
);
